import React from 'react';

import { DropdownMenuProps } from './types';
import styles from './index.module.scss';

const DropdownMenu = ({ children }: DropdownMenuProps) => (
  <ul className={styles.container} role="list">
    {children}
  </ul>
);

DropdownMenu.displayName = 'DropdownMenu';

export default DropdownMenu;
